/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import Team from "./Team";
import WaitList from "./WaitList";
import ConfirmationDialog from "./ConfirmationDialog";
import api from "../../api";
import EstatisticasJogadores from "./EstatisticasJogadores";
import Modal from "./Modal";
import SwapPlayersDialog from "./SwapPlayersDialog";
import TransferWithinAStationRoundedIcon from "@mui/icons-material/TransferWithinAStationRounded";
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import UndoRoundedIcon from "@mui/icons-material/UndoRounded";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import { useSound } from 'use-sound'; // Para gerenciar o som
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import CircularProgress from "@mui/material/CircularProgress";
import ShuffleRoundedIcon from "@mui/icons-material/ShuffleRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import HandshakeRoundedIcon from "@mui/icons-material/HandshakeRounded";
import ScienceRoundedIcon from "@mui/icons-material/ScienceRounded";
import SectionCard from "../../components/ui/SectionCard";
import EmptyState from "../../components/ui/EmptyState";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import tokens from "../../theme/tokens";
import PotesDialog from "../../components/PotesDialog";
import HistoricoPartidasPelada from "../../components/HistoricoPartidasPelada";
import { mediaDoTime } from "../../components/NotaJogador";
import useArrastarJogadores from "./useArrastarJogadores";
import { LanceDialog, contarLances, labelLance, nomeCurto } from "../../components/Lances";
import { useAuth } from "../../AuthContext";
import useTempoReal from "../../utils/tempoReal";

const TeamCard = ({ title, color, team, lastWinner, lista, arrastar, eventos, onJogador, placar, vitorias, notas, completacoes }) => {
  const media = mediaDoTime(team, notas);
  return (
  <Card sx={{ height: "100%", overflow: "hidden" }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1.5, bgcolor: color, color: "#fff" }}>
      <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: "1.5rem" }}>
        {title}
        {placar !== undefined && <Box component="span" sx={{ ml: 1.5, opacity: 0.9 }}>{placar}</Box>}
      </Typography>
      <Stack direction="row" spacing={0.75} alignItems="center">
        {media !== null && <Chip size="small" label={`Média ${media}`} title="Média das notas usadas na formação dos times" sx={{ bgcolor: "rgba(255,255,255,0.15)", color: "#fff", fontWeight: 700 }} />}
        {lastWinner && <Chip size="small" icon={<EmojiEventsRoundedIcon sx={{ color: `${tokens.color.gold} !important` }} />} label="Venceu a última" sx={{ bgcolor: "rgba(255,255,255,0.15)", color: "#fff" }} />}
      </Stack>
    </Stack>
    <Box sx={{ p: 1.5 }}>
      <Team team={team} lista={lista} arrastar={arrastar} eventos={eventos} onJogador={onJogador} vitorias={vitorias} notas={notas} completacoes={completacoes} />
    </Box>
  </Card>
  );
};

// Mínimo de jogadores na concentração para sortear (a API recusa com menos)
const MINIMO_SORTEIO = 8;

// `jogadoresNoCheckin`: quantos estão na fila (check-in sem "foi embora"); trava o sorteio abaixo do mínimo.
// `podeSortear`: diretoria ou quem fez check-in (a API recusa os demais)
const Game = ({ jogadoresNoCheckin, podeSortear = true } = {}) => {
  const [gameData, setGameData] = useState(null);
  const [listWait, setListWait] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogAction, setDialogAction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [winnerIndex, setWinnerIndex] = useState(null);
  const [lastWinnerTime1, setLastWinnerTime1] = useState(null);
  const [lastWinnerTime2, setLastWinnerTime2] = useState(null);

  const [simulacaoGameData, setSimulacaoGameData] = useState(null);
  const [simulacaoListWait, setSimulacaoListWait] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTeams, setModalTeams] = useState([]);
  const [modalWaitList, setModalWaitList] = useState([]);
  const [isSwapDialogOpen, setIsSwapDialogOpen] = useState(false);
  const [availablePlayers, setAvailablePlayers] = useState([]);
  const [aviso, setAviso] = useState(null);
  const [pedirPotes, setPedirPotes] = useState(null); // jogadores sem avaliação nem ranking (POTE_NECESSARIO)
  // Encerramento da partida em andamento: um envio por vez (toque duplo não encerra duas vezes)
  const encerrando = useRef(false);
  const [enviandoResultado, setEnviandoResultado] = useState(false);
  const iniciarEncerramento = () => {
    if (encerrando.current) return false;
    encerrando.current = true;
    setEnviandoResultado(true);
    return true;
  };
  const terminarEncerramento = () => {
    encerrando.current = false;
    setEnviandoResultado(false);
  };
  const avisarErroResultado = (error) => {
    const mensagem = error.response?.data?.message || "Não foi possível registrar o resultado.";
    setAviso({ severity: error.response?.status === 409 ? "info" : "error", message: mensagem });
    if (error.response?.status === 409) fetchGameActive({ silencioso: true });
  };



  const [time, setTime] = useState(0); // Tempo do cronômetro em segundos
  const [isRunning, setIsRunning] = useState(false); // Estado de execução do cronômetro
  const timerRef = useRef(null); // Referência para o intervalo do cronômetro

  const [playSound] = useSound('/path/to/sound.mp3'); // Caminho para o som

  // Função para atualizar o tempo
  useEffect(() => {
    if (isRunning) {
      timerRef.current = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime >= 600) { // 600 segundos = 10 minutos
            clearInterval(timerRef.current);
            playSound(); // Toca o som quando atinge 10 minutos
            return prevTime;
          }
          return prevTime + 1;
        });
      }, 1000);
    } else {
      clearInterval(timerRef.current);
    }

    return () => clearInterval(timerRef.current); // Limpa o intervalo ao desmontar
  }, [isRunning, playSound]);

  const handleStartTimer = () => setIsRunning(true);
  const handlePauseTimer = () => setIsRunning(false);
  const handleResetTimer = () => {
    setIsRunning(false);
    setTime(0);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const handleSimular = async (vencedor) => {
    await handleDefinirVencedor(vencedor, true);
    console.log("simulacaoGameData");
    console.log(simulacaoGameData);
    // setModalTeams(simulacaoGameData.partida.times);
    // setModalWaitList(simulacaoListWait);
    // setIsModalOpen(true);
  };

  const handleSimularEmpate = async () => {
    await handleTratarEmpate(true);
    // setModalTeams(simulacaoGameData.partida.times);
    // setModalWaitList(simulacaoListWait);
    // setIsModalOpen(true);
  };

  useEffect(() => {
    if (simulacaoGameData) {
      setModalTeams(simulacaoGameData.partida.times);
      setModalWaitList(simulacaoListWait);
      setIsModalOpen(true);
    }
  }, [simulacaoGameData, simulacaoListWait]);

  const fetchGameActive = async ({ silencioso = false } = {}) => {
    if (!silencioso) setLoading(true);
    try {
      const response = await api.get("getGameActive");
      console.log("API Response:", response.data);

      if (
        response.data.partida &&
        Object.keys(response.data.partida).length !== 0
      ) {
        setGameData({ ...response.data }); // Crie uma nova referência para forçar a renderização
        setLastWinnerTime1(
          arraysAreEqual(
            response.data.ultimoVencedor,
            response.data.partida.times[0]
          )
        );
        setLastWinnerTime2(
          arraysAreEqual(
            response.data.ultimoVencedor,
            response.data.partida.times[1]
          )
        );
      }

      if (response.data.espera && response.data.espera.length > 0) {
        setListWait([...response.data.espera]); // Crie uma nova referência para forçar a renderização
      } else {
        setListWait([]); // Limpe a lista de espera se não houver jogadores
      }
    } catch (error) {
      console.error("Error fetching active game:", error);
    } finally {
      if (!silencioso) setLoading(false);
    }
  };



  useEffect(() => {
    fetchGameActive();
  }, []);

  // Tempo real: times, fila de espera e placar atualizados na tela de todos
  useTempoReal(() => fetchGameActive({ silencioso: true }));

  const fetchGameData = async (endpoint) => {
    setLoading(true);
    try {
      const response = await api.post(`${endpoint}`);

      setWinnerIndex(null); // Reset winner index
      setGameData(null); // Reinicialize o estado de gameData
      setListWait([]); // Reinicialize o estado de listWait
      await fetchGameActive(); // Assegure-se de que o estado foi atualizado após definir o vencedor
    } catch (error) {
      console.error("Error fetching game data:", error);
      setAviso({ severity: "error", message: error.response?.data?.message || error.response?.data?.error || "Não foi possível sortear os times." });
    } finally {
      setLoading(false);
    }
  };

  const faltamParaSortear = jogadoresNoCheckin === undefined ? 0 : Math.max(MINIMO_SORTEIO - jogadoresNoCheckin, 0);

  // Formação dos times pelo ranking; sem avaliação nem ranking, a API pede o pote (janela) e o pedido é reenviado
  const handleSortearTimes = async (potes) => {
    setLoading(true);
    try {
      await api.post("sortearTimes", potes ? { potes } : {});
      setPedirPotes(null);
      setGameData(null);
      setListWait([]);
      await fetchGameActive();
    } catch (error) {
      const dados = error.response?.data || {};
      if (dados.code === "POTE_NECESSARIO") {
        setPedirPotes(dados.jogadores || []);
      } else {
        setPedirPotes(null);
        setAviso({ severity: error.response?.status === 409 ? "info" : "error", message: dados.message || dados.error || "Não foi possível formar os times." });
        if (error.response?.status === 409) await fetchGameActive(); // outro aparelho já formou
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSimulacaoGameData(null);
    setSimulacaoListWait([]);
  };

  const handleUpdateWaitList = async () => {
    setLoading(true);
    try {
      const response = await api.post("updateWaitList", {
        partidaId: gameData.partida._id,
      });

      if (response.status === 200) {
        setListWait([]); // Reinicialize o estado de listWait
        await fetchGameActive(); // Assegure-se de que o estado foi atualizado após definir o vencedor
      }
    } catch (error) {
      console.error("Error update list wait:", error);
    } finally {
      setLoading(false);
    }
  };

  const onUpdatePlayerPosition = async (direction,user_name) => {
    setLoading(true);
    try {
      const response = await api.post("changePositionWaitList", {
        partidaId: gameData.partida._id,
        user_name: user_name,
        direction:direction
      });

      if (response.status === 200) {
        setListWait([]); // Reinicialize o estado de listWait
        await fetchGameActive(); // Assegure-se de que o estado foi atualizado após definir o vencedor
      }
    } catch (error) {
      console.error("Error update list wait:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDefinirVencedor = async (vencedor, simulacao) => {
    if (!simulacao && !iniciarEncerramento()) return;
    setLoading(true);
    try {
      const response = await api.post("definirVencedor", {
        partidaId: gameData.partida._id,
        vencedor: vencedor,
        simulacao: simulacao,
      });
      if (response.status === 200) {
        if (simulacao) {
          if (
            response.data.partida &&
            Object.keys(response.data.partida).length !== 0
          ) {
            setSimulacaoGameData(null);

            setSimulacaoGameData({ ...response.data }); // Crie uma nova referência para forçar a renderização
          }

          setSimulacaoListWait([]);
          if (response.data.espera && response.data.espera.length > 0) {
            setSimulacaoListWait([...response.data.espera]); // Crie uma nova referência para forçar a renderização
          } else {
            setSimulacaoListWait([]); // Limpe a lista de espera se não houver jogadores
          }
        } else {
          setWinnerIndex(vencedor);
          setGameData(null); // Reinicialize o estado de gameData
          setListWait([]); // Reinicialize o estado de listWait
          await fetchGameActive(); // Assegure-se de que o estado foi atualizado após definir o vencedor
        }
      }
    } catch (error) {
      console.error("Error defining winner:", error);
      if (!simulacao) avisarErroResultado(error);
    } finally {
      setLoading(false);
      if (!simulacao) terminarEncerramento();
    }
  };

  const handleTratarEmpate = async (simulacao) => {
    if (!simulacao && !iniciarEncerramento()) return;
    setLoading(true);
    try {
      const response = await api.post("tratarEmpate", {
        partidaId: gameData.partida._id,
        simulacao: simulacao,
      });

      if (response.status === 200) {
        if (simulacao) {
          if (
            response.data.partida &&
            Object.keys(response.data.partida).length !== 0
          ) {
            setSimulacaoGameData(null);

            setSimulacaoGameData({ ...response.data }); // Crie uma nova referência para forçar a renderização
          }

          setSimulacaoListWait([]);
          if (response.data.espera && response.data.espera.length > 0) {
            setSimulacaoListWait([...response.data.espera]); // Crie uma nova referência para forçar a renderização
          } else {
            setSimulacaoListWait([]); // Limpe a lista de espera se não houver jogadores
          }
        } else {
          setWinnerIndex(null); // Resetar o índice do vencedor

          // Reinicialize os estados de gameData e listWait para garantir que não mantenham dados antigos
          setGameData(null);
          setListWait([]);
          await fetchGameActive();
        }

        // Aguarde a atualização dos dados do jogo ativo

        // Verifique se o estado foi atualizado corretamente
        console.log("GameData após tratar empate:", gameData);
        console.log("ListWait após tratar empate:", listWait);
      }
    } catch (error) {
      console.error("Error handling draw:", error);
      if (!simulacao) avisarErroResultado(error);
    } finally {
      setLoading(false);
      if (!simulacao) terminarEncerramento();
    }
  };

  // Diretoria: desfaz o último resultado (apaga a partida montada depois dele e reabre a anterior)
  const [desfazerAberto, setDesfazerAberto] = useState(false);
  const handleDesfazerResultado = async () => {
    setDesfazerAberto(false);
    if (!iniciarEncerramento()) return;
    setLoading(true);
    try {
      const response = await api.post("partidas/desfazer-resultado");
      setAviso({ severity: "success", message: response.data?.message || "Resultado desfeito." });
      await fetchGameActive({ silencioso: true });
    } catch (error) {
      setAviso({ severity: "error", message: error.response?.data?.message || "Não foi possível desfazer o resultado." });
    } finally {
      setLoading(false);
      terminarEncerramento();
    }
  };

  const openDialog = (action) => {
    setDialogAction(() => action);
    setIsDialogOpen(true);
  };

  const executeDialogAction = () => {
    if (dialogAction) {
      dialogAction();
      setIsDialogOpen(false);
    }
  };

  const removePlayer = async (userId) => {
    setLoading(true);
    try {
      const response = await api.post("removerJogador", { userId });
      if (response.status === 200) {
        setGameData(response.data);
        // setMessage('Jogador removido com sucesso.');
        // setSeverity('success');
        // setOpenMessage(true);
        // Reinicialize os estados de gameData e listWait para garantir que não mantenham dados antigos
        setGameData(null);
        setListWait([]);

        // Aguarde a atualização dos dados do jogo ativo
        await fetchGameActive();
      }
    } catch (error) {
      console.error("Error removing player:", error);
      //   setMessage(error.response.data.error || 'Erro ao remover jogador.');
      //   setSeverity('error');
      //   setOpenMessage(true);
    } finally {
      setLoading(false);
    }
  };

  function arraysAreEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    return array1.every(
      (player, index) => player.user_name === array2[index].user_name
    );
  }

  // Arrastar e soltar: fila ↔ time e time ↔ time trocam os dois jogadores; dentro da fila muda a posição
  const nomeLista = { time0: "Time 1", time1: "Time 2", espera: "fila" };
  const soltarJogador = async (origem, alvo) => {
    if (origem.lista === alvo.lista && origem.lista !== "espera") return; // mesmo time: nada muda
    try {
      await api.post("trocarPosicoes", { partidaId: gameData.partida._id, origem, destino: alvo });
      await fetchGameActive({ silencioso: true }); // sem carregamento na tela (a lista não "pula")
      setAviso({
        severity: "success",
        message:
          origem.lista === "espera" && alvo.lista === "espera"
            ? `${origem.user_name} agora está na posição de ${alvo.user_name} na fila.`
            : `${origem.user_name} (${nomeLista[origem.lista]}) trocou com ${alvo.user_name} (${nomeLista[alvo.lista]}).`,
      });
    } catch (error) {
      setAviso({ severity: "error", message: error.response?.data?.message || "Não foi possível trocar os jogadores." });
    }
  };
  const arrastar = useArrastarJogadores(soltarJogador);

  // Lances (gol, assistência, cartões) — Admin/Diretor, pela mesma API da tela do árbitro
  const { userLogado } = useAuth();
  // Vitórias de cada jogador na pelada (troféus ao lado do nome)
  const vitorias = Object.fromEntries(
    Object.values((gameData && gameData.estatisticasJogadores) || {}).map((e) => [e.user_name, e.vitorias || 0])
  );
  const ehDiretoria = userLogado && (userLogado.perfil === "Admin" || userLogado.perfil === "Diretor");
  const [jogadorLance, setJogadorLance] = useState(null); // { time, user_name }
  const [enviandoLance, setEnviandoLance] = useState(false);
  const eventos = gameData?.partida?.eventos || [];
  const placar = [0, 1].map((t) => eventos.filter((e) => e.tipo === "gol" && e.time === t).length);

  const aplicarEventos = (partida) =>
    setGameData((atual) => (atual ? { ...atual, partida: { ...atual.partida, eventos: partida.eventos } } : atual));

  const lancar = async (tipo) => {
    const { time, user_name } = jogadorLance;
    setEnviandoLance(true);
    try {
      const response = await api.post(`arbitragem/partidas/${gameData.partida._id}/eventos`, { tipo, time, user_name });
      aplicarEventos(response.data.partida);
      setJogadorLance(null);
      if (navigator.vibrate) navigator.vibrate(60);
      setAviso({ severity: "success", message: `${labelLance(tipo)} · ${nomeCurto(user_name)}` });
    } catch (error) {
      setAviso({ severity: "error", message: error.response?.data?.error || "Não foi possível registrar o lance." });
    } finally {
      setEnviandoLance(false);
    }
  };

  const desfazerLance = async (evento) => {
    setEnviandoLance(true);
    try {
      const response = await api.remove(`arbitragem/partidas/${gameData.partida._id}/eventos/${evento._id}`);
      aplicarEventos(response.data.partida);
      setAviso({ severity: "success", message: "Lance desfeito." });
    } catch (error) {
      setAviso({ severity: "error", message: error.response?.data?.error || "Não foi possível desfazer o lance." });
    } finally {
      setEnviandoLance(false);
    }
  };

  // Função para abrir o diálogo de troca de jogadores
  const openSwapDialog = () => {
    const players = [
      ...gameData.partida.times[0],
      ...gameData.partida.times[1],
      ...listWait,
    ];
    setAvailablePlayers(players); // Atualize com a lista de espera
    setIsSwapDialogOpen(true);
  };

  // Função para confirmar a troca de jogadores
  const handleSwapPlayers = async (playerOut, playerIn) => {
    try {
      setLoading(true);
      const time1 = gameData.partida.times[0];
      const time2 = gameData.partida.times[1];
      const outTime1 = time1.find((jogador) => jogador.user_name === playerOut);
      const outTime2 = time2.find((jogador) => jogador.user_name === playerOut);
      let timeIndex = null;
      if (outTime1 !== undefined) {
        timeIndex = 0;
      } else if (outTime2 !== undefined) {
        timeIndex = 1;
      } else {
        alert("Jogador " + playerOut + " não esta em jogo!");
        return;
      }

      const inTime1 = listWait.find((jogador) => jogador.user_name === playerIn);
      if (inTime1 == undefined) {
        alert("Jogador " + playerIn + " não esta na lista de espera!");
        return;
      }
   

      await api.post("changePlayer", {
        partidaId: gameData.partida._id,
        timeIndex,
        jogadorSaidaNome: playerOut,
        jogadorEntradaNome: playerIn,
      });
      await fetchGameActive(); // Atualiza o estado após a troca
    } catch (error) {
      console.error("Erro ao trocar jogadores:", error);
    } finally {
      setLoading(false);
      setIsSwapDialogOpen(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Card sx={{ bgcolor: tokens.color.ink, color: "#fff", border: "none" }}>
        <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={2} sx={{ p: { xs: 2, sm: 3 } }}>
          <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
            <Typography variant="overline" sx={{ opacity: 0.7 }}>Cronômetro · 10 minutos</Typography>
            <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: { xs: "3.5rem", sm: "4.5rem" }, lineHeight: 1, color: time >= 600 ? tokens.color.brandLight : "#fff" }}>
              {formatTime(time)}
            </Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Button variant="contained" startIcon={<PlayArrowIcon />} onClick={handleStartTimer} disabled={isRunning}>Iniciar</Button>
            <Button variant="outlined" startIcon={<PauseIcon />} onClick={handlePauseTimer} sx={{ color: "#fff", borderColor: "rgba(255,255,255,0.4)" }}>Pausar</Button>
            <Button variant="outlined" startIcon={<StopIcon />} onClick={handleResetTimer} sx={{ color: "#fff", borderColor: "rgba(255,255,255,0.4)" }}>Zerar</Button>
          </Stack>
        </Stack>
      </Card>

      {loading && (
        <Box sx={{ textAlign: "center", py: 4 }}><CircularProgress /></Box>
      )}

      {!gameData && !loading && (
        <Card>
          <EmptyState
            icon={<ShuffleRoundedIcon />}
            title="Nenhuma partida em andamento"
            description={
              !podeSortear
                ? "Quem fez check-in na pelada (ou a diretoria) pode sortear os times."
                : faltamParaSortear > 0
                ? `${jogadoresNoCheckin} de ${MINIMO_SORTEIO} jogadores no check-in. Falta${faltamParaSortear === 1 ? '' : 'm'} ${faltamParaSortear} para sortear os times.`
                : `Com pelo menos ${MINIMO_SORTEIO} jogadores na concentração, os dois primeiros times são formados equilibrados pelas avaliações da pelada (ou o ranking do torneio).`
            }
            action={<Button variant="contained" size="large" startIcon={<ShuffleRoundedIcon />} onClick={() => handleSortearTimes()} disabled={loading || !podeSortear || faltamParaSortear > 0}>Sortear times</Button>}
          />
        </Card>
      )}

      {gameData && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TeamCard title="Time 1" color={tokens.color.team1} team={gameData.partida.times[0]} lastWinner={lastWinnerTime1} lista="time0" arrastar={arrastar} eventos={eventos} placar={placar[0]} onJogador={ehDiretoria ? setJogadorLance : undefined} vitorias={vitorias} notas={gameData.notas} completacoes={gameData.completacoes} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TeamCard title="Time 2" color={tokens.color.team2} team={gameData.partida.times[1]} lastWinner={lastWinnerTime2} lista="time1" arrastar={arrastar} eventos={eventos} placar={placar[1]} onJogador={ehDiretoria ? setJogadorLance : undefined} vitorias={vitorias} notas={gameData.notas} completacoes={gameData.completacoes} />
            </Grid>
          </Grid>
          <Typography variant="caption" color="text.secondary" sx={{ mt: -1.5 }}>
            Dica: arraste um jogador pela alça e solte sobre outro para trocar os dois de lugar (entre os times ou com a fila).
            {ehDiretoria && " Toque no nome para lançar gol, assistência ou cartão."}
          </Typography>

          <SectionCard title="Resultado da partida" subtitle="Confirme o resultado para montar a próxima partida com a fila de espera.">
            <Grid container spacing={1.5}>
              <Grid item xs={12} sm={4}>
                <Button fullWidth size="large" variant="contained" startIcon={<EmojiEventsRoundedIcon />} onClick={() => openDialog(() => handleDefinirVencedor(0, false))} disabled={enviandoResultado} sx={{ bgcolor: tokens.color.team1 }}>
                  Time 1 venceu
                </Button>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button fullWidth size="large" variant="outlined" color="inherit" startIcon={<HandshakeRoundedIcon />} onClick={() => openDialog(() => handleTratarEmpate(false))} disabled={enviandoResultado}>
                  Empate
                </Button>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button fullWidth size="large" variant="contained" color="secondary" startIcon={<EmojiEventsRoundedIcon />} onClick={() => openDialog(() => handleDefinirVencedor(1, false))} disabled={enviandoResultado}>
                  Time 2 venceu
                </Button>
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }}>
              <Chip size="small" icon={<ScienceRoundedIcon />} label="Simular sem salvar" />
            </Divider>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} justifyContent="center">
              <Button onClick={() => handleSimular(0)}>Simular Time 1 vence</Button>
              <Button onClick={handleSimularEmpate}>Simular empate</Button>
              <Button onClick={() => handleSimular(1)}>Simular Time 2 vence</Button>
            </Stack>
            <Divider sx={{ my: 2 }} />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} justifyContent="center">
              <Button variant="outlined" startIcon={<TransferWithinAStationRoundedIcon />} onClick={() => openSwapDialog()}>
                Trocar jogadores
              </Button>
              <Button variant="outlined" startIcon={<AutorenewRoundedIcon />} onClick={() => handleUpdateWaitList()}>
                Atualizar fila
              </Button>
              {ehDiretoria && (
                <Button variant="outlined" color="warning" startIcon={<UndoRoundedIcon />} onClick={() => setDesfazerAberto(true)} disabled={enviandoResultado}>
                  Desfazer último resultado
                </Button>
              )}
            </Stack>
          </SectionCard>

          {gameData.venceuDuasVezes && gameData.venceuDuasVezes.length > 0 && (
            <WaitList
              title={"Time com 2 vitórias"}
              onRemovePlayer={removePlayer}
              waitList={gameData.venceuDuasVezes}
              vitorias={vitorias}
              notas={gameData.notas} completacoes={gameData.completacoes}
            />
          )}
          <WaitList
            title={"Fila de espera"}
            onRemovePlayer={removePlayer}
            waitList={listWait}
            onUpdatePlayerPosition={onUpdatePlayerPosition}
            arrastar={arrastar}
            vitorias={vitorias}
            notas={gameData.notas} completacoes={gameData.completacoes}
          />
          <EstatisticasJogadores
            estatisticas={gameData.estatisticasJogadores}
          />
          <HistoricoPartidasPelada peladaId={gameData.partida.peladaId} atualizarCom={gameData.partida._id} podeExcluir={ehDiretoria} />
        </>
      )}
      <ConfirmationDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={executeDialogAction}
      />
      <ConfirmationDialog
        isOpen={desfazerAberto}
        onClose={() => setDesfazerAberto(false)}
        onConfirm={handleDesfazerResultado}
        title="Desfazer o último resultado?"
        message="A partida em andamento é apagada (com os lances dela) e a partida anterior volta a ficar sem resultado, com a fila de antes. Use para corrigir um resultado lançado errado; pode repetir para voltar mais rodadas."
        confirmLabel="Desfazer resultado"
      />
      <SwapPlayersDialog
        isOpen={isSwapDialogOpen}
        onClose={() => setIsSwapDialogOpen(false)}
        onConfirm={handleSwapPlayers}
        availablePlayers={availablePlayers}
      />
      <Modal
        isOpen={isModalOpen}
        onClose={() => handleCloseModal()}
        teams={modalTeams}
        waitList={modalWaitList}
      />
      <LanceDialog
        jogador={jogadorLance}
        onLance={lancar}
        onClose={() => setJogadorLance(null)}
        eventos={jogadorLance ? contarLances(eventos, jogadorLance.time, jogadorLance.user_name).eventos : []}
        onDesfazer={desfazerLance}
        enviando={enviandoLance}
      />
      {arrastar.arraste && (
        // "Fantasma" que acompanha o dedo/mouse durante o arraste
        <Chip
          label={
            !arrastar.arraste.alvo
              ? arrastar.arraste.nome
              : arrastar.arraste.origem.lista === "espera" && arrastar.arraste.alvo.lista === "espera"
              ? `${arrastar.arraste.nome} → lugar de ${arrastar.arraste.alvo.user_name}`
              : `${arrastar.arraste.nome} ⇄ ${arrastar.arraste.alvo.user_name}`
          }
          color="primary"
          sx={{ position: "fixed", left: arrastar.arraste.x + 12, top: arrastar.arraste.y - 36, zIndex: 2000, pointerEvents: "none", boxShadow: 6, maxWidth: 280 }}
        />
      )}
      <PotesDialog jogadores={pedirPotes} enviando={loading} onConfirmar={(potes) => handleSortearTimes(potes)} onFechar={() => setPedirPotes(null)} />
      <Snackbar open={Boolean(aviso)} autoHideDuration={4000} onClose={() => setAviso(null)} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
        {aviso ? <Alert variant="filled" severity={aviso.severity} onClose={() => setAviso(null)}>{aviso.message}</Alert> : <span />}
      </Snackbar>
    </Stack>
  );
};

export default Game;
